import React, { useState, useEffect } from 'react';
import { Card, Form, Switch, Input, Button, Select, message, Spin, Alert, Typography, Space, Tooltip } from 'antd';
import { InfoCircleOutlined, ReloadOutlined, KeyOutlined, LockOutlined } from '@ant-design/icons';
import api from '../../../services/api';

const { Text, Title } = Typography;
const { Option } = Select;

const LicenseEncryption = ({ settings = {}, onUpdate, loading }) => {
  const [form] = Form.useForm();
  const [generating, setGenerating] = useState(false);
  const [logsLoading, setLogsLoading] = useState(false);

  // Initialize form with settings
  useEffect(() => {
    if (settings) {
      form.setFieldsValue({
        encryption_enabled: settings.encryption_enabled || false,
        // key_rotation_days: settings.key_rotation_days || 90,
        // validation_strictness: settings.validation_strictness || 'medium',
        // offline_validation: settings.offline_validation || false
      });
    }
  }, [settings, form]);

  const handleSubmit = async (values) => {
    try {
      await onUpdate(values);
      message.success('License encryption settings updated successfully');
    } catch (error) {
      console.error('Error updating license encryption settings:', error);
      message.error('Failed to update license encryption settings');
    }
  };

  const generateLicenseKey = () => {
      const key = `SEC-${Math.random().toString(36).substring(2, 10).toUpperCase()}`;
      //form.setFieldsValue({ license_key: key });
      console.log("key=====>",key)
  }

  const generateNewKeyPair = async () => {
    generateLicenseKey()

    // try {
    //   setGenerating(true);
    //   // Call API to generate new key pair
    //   await api.settings.licenseEncryption.rotateKeys();
    //   message.success('New encryption key pair generated successfully');
    //   // Refresh settings to get the new key info
    //   onUpdate();
    // } catch (error) {
    //   console.error('Error generating key pair:', error);
    //   message.error('Failed to generate new key pair');
    // } finally {
    //   setGenerating(false);
    // }
  };

  const fetchValidationLogs = async () => {
    try {
      setLogsLoading(true);
      const response = await api.licenses.getValidationFailures({
        limit: 10, // Show last 10 validation failures
        sort: 'timestamp:desc'
      });
    } catch (error) {
      console.error('Error fetching validation logs:', error);
      message.error('Failed to load validation logs');
    } finally {
      setLogsLoading(false);
    }
  };

  useEffect(() => {
    fetchValidationLogs();
  }, []);

  return (
    <div className="license-encryption-settings">
      <Card 
        title={
          <Space>
            <LockOutlined />
            <span>License Encryption Settings</span>
          </Space>
        }
        style={{ marginBottom: 24 }}
        extra={
          <Button 
            type="primary" 
            icon={<ReloadOutlined />} 
            onClick={() => onUpdate()}
            loading={loading}
          >
            Refresh
          </Button>
        }
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            encryption_enabled: false,
            // key_rotation_days: 90,
            // validation_strictness: 'medium',
            // offline_validation: false
          }}
        >
          <Form.Item
            name="encryption_enabled"
            label={
              <Space>
                <span>Enable License Encryption</span>
                <Tooltip title="Encrypts license data in transit and at rest">
                  <InfoCircleOutlined />
                </Tooltip>
              </Space>
            }
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) => 
              prevValues.encryption_enabled !== currentValues.encryption_enabled
            }
          >
            {({ getFieldValue }) =>
              getFieldValue('encryption_enabled') && (
                <>
                  <Form.Item
                    name="key_rotation_days"
                    label={
                      <Space>
                        <span>Key Rotation (days)</span>
                        <Tooltip title="How often to automatically rotate encryption keys">
                          <InfoCircleOutlined />
                        </Tooltip>
                      </Space>
                    }
                    rules={[
                      { required: true, message: 'Please enter key rotation period' },
                      { type: 'number', min: 1, max: 365, message: 'Must be between 1 and 365 days' }
                    ]}
                  >
                    <Input type="number" min={1} max={365} />
                  </Form.Item>

                  <Form.Item
                    name="validation_strictness"
                    label="Validation Strictness"
                    tooltip="Controls how strictly license validations are enforced"
                  >
                    <Select>
                      <Option value="low">Low - Basic validation only</Option>
                      <Option value="medium">Medium - Standard validation (recommended)</Option>
                      <Option value="high">High - Strict validation with additional checks</Option>
                    </Select>
                  </Form.Item>

                  <Form.Item>
                    <Button 
                      type="primary" 
                      htmlType="submit" 
                      loading={loading}
                      style={{ marginRight: 8 }}
                    >
                      Save Settings
                    </Button>
                    
                  </Form.Item>
                </>
              )
            }
          </Form.Item>
        </Form>
      </Card>

      
    </div>
  );
};

export default LicenseEncryption;
